export const blogsData = [
  {
    id: 1,
    title: "Building a Lightning-Fast NSE Stock Data Scraper: From API Calls to Full-Stack Web App",
    description: "Learn how to build a high-performance stock data scraper for NSE (National Stock Exchange) using modern web technologies. This comprehensive guide covers API integration, data processing, and creating a full-stack web application.",
    url: "https://dev.to/singhanuj620/building-a-lightning-fast-nse-stock-data-scraper-from-api-calls-to-full-stack-web-app-4hl7",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--Bpn-Mt0W--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/k7bl3s7umm65659of2iw.jpg",
    published_at: "2024-08-27T10:00:00Z",
    tag_list: ["webscraping", "nse", "javascript", "webdev"],
    public_reactions_count: 12,
    comments_count: 3,
    page_views_count: 850,
    reading_time_minutes: 6
  },
  {
    id: 2,
    title: "Apollo GraphQL - Setup Guide",
    description: "A comprehensive guide to setting up Apollo GraphQL in your React application. Learn how to configure Apollo Client, write queries and mutations, and handle state management with GraphQL.",
    url: "https://dev.to/singhanuj620/apollo-graphql-setup-guide-5d67",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--6o_TkDzJ--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/ndnzyl98cm6oui9vm8jx.png",
    published_at: "2024-04-06T14:30:00Z",
    tag_list: ["graphql", "webdev", "react", "javascript"],
    public_reactions_count: 8,
    comments_count: 2,
    page_views_count: 620,
    reading_time_minutes: 2
  },
  {
    id: 3,
    title: "useReducer () | React Hook with project",
    description: "Deep dive into React's useReducer hook and learn when and how to use it effectively. Build a practical project to understand state management patterns in React applications.",
    url: "https://dev.to/singhanuj620/usereducer-react-hook-with-project-1pg",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--fFxTBYJJ--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/ymvtsr1kbu17lcl61bbm.png",
    published_at: "2022-09-14T16:45:00Z",
    tag_list: ["react", "redux", "javascript", "webdev"],
    public_reactions_count: 56,
    comments_count: 11,
    page_views_count: 1560,
    reading_time_minutes: 3
  },
  {
    id: 4,
    title: "JWT explained with project",
    description: "Learn about JSON Web Tokens (JWT) through a practical project implementation. This article covers the basics of JWT, how it works, security considerations, and how to implement it in your applications.",
    url: "https://dev.to/singhanuj620/jwt-explained-with-project-37en",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--Bpn-Mt0W--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/k7bl3s7umm65659of2iw.jpg",
    published_at: "2021-12-13T10:00:00Z",
    tag_list: ["javascript", "tutorial", "webdev", "beginners"],
    public_reactions_count: 45,
    comments_count: 8,
    page_views_count: 1250,
    reading_time_minutes: 4
  },
  {
    id: 5,
    title: "React Redux | Learn the redux easily with project",
    description: "Master Redux state management in React applications through hands-on project development. This comprehensive guide covers Redux fundamentals, actions, reducers, and best practices.",
    url: "https://dev.to/singhanuj620/react-redux-learn-the-redux-easily-with-project-aji",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--6o_TkDzJ--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/ndnzyl98cm6oui9vm8jx.png",
    published_at: "2021-07-05T14:30:00Z",
    tag_list: ["javascript", "react", "redux", "tutorial"],
    public_reactions_count: 72,
    comments_count: 15,
    page_views_count: 2100,
    reading_time_minutes: 4
  },
  {
    id: 6,
    title: "Mongoose Populate() in most simple way",
    description: "Understand MongoDB relationships and Mongoose populate() method through practical examples. Learn how to efficiently manage related data in your Node.js applications and work with collections.",
    url: "https://dev.to/singhanuj620/mongoose-populate-in-most-simple-way-how-to-import-a-collection-into-another-schema-in-mongodb-4nnf",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--shTyd8F7--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/dwcj63fdldqgmvtptoga.png",
    published_at: "2021-04-18T09:15:00Z",
    tag_list: ["mongodb", "mongoose", "node", "javascript"],
    public_reactions_count: 38,
    comments_count: 6,
    page_views_count: 890,
    reading_time_minutes: 2
  },
  {
    id: 7,
    title: "How to fix nodemon error- nodemon.ps1 cannot be loaded because running scripts is disabled on this system",
    description: "Step-by-step solution to fix the common nodemon PowerShell execution policy error on Windows systems. Learn how to enable script execution and troubleshoot Node.js development environment issues.",
    url: "https://dev.to/singhanuj620/how-to-fix-nodemon-error-nodemon-ps1-cannot-be-loaded-because-running-scripts-is-disabled-on-this-system-1dc3",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--shTyd8F7--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/dwcj63fdldqgmvtptoga.png",
    published_at: "2021-03-19T11:20:00Z",
    tag_list: ["node", "javascript", "nodemon", "webdev"],
    public_reactions_count: 24,
    comments_count: 4,
    page_views_count: 680,
    reading_time_minutes: 1
  },
  {
    id: 8,
    title: "How to scroll to the top while using react-router-dom",
    description: "Learn how to implement automatic scroll-to-top functionality when navigating between routes in React applications. Essential UX improvement for better user experience.",
    url: "https://dev.to/singhanuj620/how-to-scroll-to-the-top-while-using-react-router-dom-30nd",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--fFxTBYJJ--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/ymvtsr1kbu17lcl61bbm.png",
    published_at: "2021-03-07T13:45:00Z",
    tag_list: ["react", "router", "dom", "javascript"],
    public_reactions_count: 18,
    comments_count: 3,
    page_views_count: 420,
    reading_time_minutes: 1
  },
  {
    id: 9,
    title: "How Google is competing against Facebook, Twitter, and Linkedin in marketing space? #PeopleCard",
    description: "Analysis of Google's People Card feature and how it positions Google to compete with major social media platforms in the professional networking and personal branding space.",
    url: "https://dev.to/singhanuj620/how-google-is-competing-against-facebook-twitter-and-linkedin-in-marketing-space-peoplecard-4kdh",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--Bpn-Mt0W--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/k7bl3s7umm65659of2iw.jpg",
    published_at: "2020-08-12T15:30:00Z",
    tag_list: ["database", "marketing", "google", "social"],
    public_reactions_count: 15,
    comments_count: 2,
    page_views_count: 380,
    reading_time_minutes: 1
  },
  {
    id: 10,
    title: "UrlShortner using Nodejs and MongoDb | Node.js Project | Javascript",
    description: "Build a complete URL shortening service using Node.js and MongoDB. Learn about database design, API development, and implementing click tracking functionality.",
    url: "https://dev.to/singhanuj620/urlshortner-using-nodejs-and-mongodb-25ec",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--shTyd8F7--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/dwcj63fdldqgmvtptoga.png",
    published_at: "2020-07-03T12:00:00Z",
    tag_list: ["node", "npm", "mongodb", "javascript"],
    public_reactions_count: 42,
    comments_count: 7,
    page_views_count: 950,
    reading_time_minutes: 3
  },
  {
    id: 11,
    title: "Can I Use 'Variables' in CSS ? Yes !! Let's see how",
    description: "Discover the power of CSS custom properties (CSS variables) and how they can make your stylesheets more maintainable and dynamic. Learn syntax, browser support, and practical use cases.",
    url: "https://dev.to/singhanuj620/can-i-use-variables-in-css-yes-let-s-see-how-13b4",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--Bpn-Mt0W--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/k7bl3s7umm65659of2iw.jpg",
    published_at: "2020-07-03T10:15:00Z",
    tag_list: ["css", "html", "javascript", "webdev"],
    public_reactions_count: 28,
    comments_count: 5,
    page_views_count: 720,
    reading_time_minutes: 1
  },
  {
    id: 12,
    title: "Using CSS Module in Latest React 16.12.0",
    description: "Learn how to implement CSS Modules in React applications for better component styling isolation. Understand the benefits of scoped CSS and how to configure CSS Modules in your React projects.",
    url: "https://dev.to/singhanuj620/using-css-module-in-latest-react-16-12-0-5e86",
    cover_image: "https://res.cloudinary.com/practicaldev/image/fetch/s--fFxTBYJJ--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/ymvtsr1kbu17lcl61bbm.png",
    published_at: "2020-01-15T14:20:00Z",
    tag_list: ["css", "react", "javascript", "webdev"],
    public_reactions_count: 22,
    comments_count: 4,
    page_views_count: 540,
    reading_time_minutes: 1
  }
];

export const getBlogStats = (blogs = blogsData) => {
  return {
    totalArticles: blogs.length,
    totalReactions: blogs.reduce((total, blog) => total + (blog.public_reactions_count || 0), 0),
    totalViews: blogs.reduce((total, blog) => total + (blog.page_views_count || 0), 0),
    totalComments: blogs.reduce((total, blog) => total + (blog.comments_count || 0), 0)
  };
};

export const filterBlogsByTag = (blogs = blogsData, tag) => {
  if (!tag) return blogs;
  
  return blogs.filter(blog => 
    blog.tag_list && blog.tag_list.some(blogTag => 
      blogTag.toLowerCase().includes(tag.toLowerCase())
    )
  );
};

export const searchBlogs = (blogs = blogsData, query) => {
  if (!query) return blogs;
  
  const lowercaseQuery = query.toLowerCase();
  return blogs.filter(blog => 
    blog.title.toLowerCase().includes(lowercaseQuery) ||
    (blog.description && blog.description.toLowerCase().includes(lowercaseQuery))
  );
};

export const getMostPopularBlogs = (limit = 5) => {
  return [...blogsData]
    .sort((a, b) => (b.public_reactions_count || 0) - (a.public_reactions_count || 0))
    .slice(0, limit);
};

export const getLatestBlogs = (limit = 5) => {
  return [...blogsData]
    .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))
    .slice(0, limit);
};

export const getAllBlogTags = () => {
  const allTags = blogsData.reduce((tags, blog) => {
    if (blog.tag_list) {
      tags.push(...blog.tag_list);
    }
    return tags;
  }, []);
  
  return [...new Set(allTags)].sort();
};